export default __webpack_public_path__ + "static/media/info-circle.8a5995b0.svg";